<template>
 <div>
     <div class="row justify-content-center ">
         <div class="col-md-8 pt-3">
             <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Prescriptions</p>
         </div>
         <div class="col-md-4 pt-3 text-right pr-4">
             <a href="/my-health/prescriptions/edit" aria-label="My Prescriptions - Edit" class="color-sky-blue-3" v-if="rxs.length > 0">
                 Edit
             </a>
         </div>
     </div>
     <div class="row justify-content-center ">
         <div class="col-md-12">
             <div class="col-md-12 mb-2">
                 <a href="/my-health/prescriptions/add" class="btn btn-primary btn-sb">Add new prescription</a>
             </div>

             <ul class="list-group mb-3" v-if="rxs.length>0">
                 <li :class="(r.conditions.length>0?'border-bottom-0 ':'')+'list-group-item border-top-0 border-right-0 border-left-0 ml-0 mr-0'"  v-for="(r, key) in rxs" v-if="view_more || key < 4">
                     <div class="row">
                         <div class="col-md-9 sb-list-fitem-regular">
                             {{ r.pre_sr ? r.pre_srname : (r.prescription_data?r.prescription_data.prd_name:'') }}
                             ({{ r?.pre_dosage }} {{ r?.dosage?.dos_type }})
                         </div>
                         <div class="col-md-3 text-right sb-list-sitem">
                             <a href="#" class="text-danger" @click="deleteRxById(r)" :aria-label="((r.pre_sr ? r.pre_srname : r.prescription_data.prd_name) + ' - Remove')">
                                 Remove
                             </a>
                         </div>
                     </div>
                     <ul class="list-group">
                         <li class="list-group-item border-top-0 border-left-0 border-right-0 pt-1 pb-1 sb-list-thitem-regular" v-for="c in r.conditions">
                             {{ c.cnd_sr ? c.cnd_srname : (c.condition_data?c.condition_data.cdd_name:'') }}
                         </li>
                     </ul>
                 </li>
             </ul>
             <div v-if="rxs.length>4" class="text-right mb-3 mr-3">
                 <a href="#" @click.prevent="view_more=!view_more" aria-label="View Less Prescriptions" v-if="view_more">View Less</a>
                 <a href="#" @click.prevent="view_more=!view_more" aria-label="View More Prescriptions" v-else>View More</a>
             </div>
         </div>
     </div>
 </div>
</template>

<script>
export default {
    props:['prescriptions'],
    mounted() {
        this.listRx(true);
    },
    data() {
        return {
            route: '/api/prescriptions',
            rxs: [],
            view_more: false
        }
    },
    methods: {
        listRx(fromProp = false) {
            if (fromProp) {
                this.rxs = this.prescriptions;
                bus.$emit('listRX', this.rxs);
            } else {
                this.$http.get(this.route)
                    .then(function (response) {
                        this.rxs = response.data;
                        bus.$emit('listRX', this.rxs);
                    }, (response) => {
                        this._handleErrors(response.data, '#rx-form')
                    })
            }
        },
        deleteRxById(rx) {
            if (!confirm('Do you really want to delete this prescription?'))
                return

            this.$http.delete(this.route + '/' + rx.pre_id)
                .then(function (response) {
                    this.listRx();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Prescription was deleted!'
                    });
                    this.showModal = false;
                }, (response) => {
                    this._handleErrors(response.data, '#rx-form')
                })
        },
        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        }
    }

}
</script>
